module.exports = __webpack_public_path__ + "static/media/comparison-table-blurred-1500w.c244c12a.jpg";